import React from "react";
import _ from "lodash";

function FullNameWithTitleLabel(props) {
  return <span> {_.startCase(_.toLower(props.name))}</span>;
}

export default FullNameWithTitleLabel;
